@if (banner$ | async; as banner) {
  <div [class]="banner.bannerClass">
    <p-button (click)="onClick(banner)" [text]="true" styleClass="text-color">
      <i>{{ banner.icon }}</i>
      <b class="ml-2">
        {{ banner.description }}
      </b>
    </p-button>
    <p-button (click)="onClick(banner)" styleClass="white-space-nowrap mr-2">
      <i class="hidden sm:inline">{{ banner.icon }}</i>
      <b class="ml-2"
        ><span class="hidden sm:inline">{{ banner.buttonText }}</span> &gt;&gt;</b
      >
    </p-button>
  </div>
}
